export default [
  {
    name: "NIFTY 50",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY NEXT 50",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY 100",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY 200",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY 500",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY MIDCAP 150",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY MIDCAP 50",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY FULL MIDCAP 100",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY FREE FLOAT MIDCAP 100",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY SMALLCAP 250",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY SMALLCAP 50",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY FULL SMALLCAP 100",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY FREE FLOAT SMALLCAP 100",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY LargeMidcap 250",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY MIDSMALLCAP 400",
    label: "Broad Market Indices"
  },
  {
    name: "NIFTY AUTO",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY BANK",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY ENERGY",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY FINANCIAL SERVICES",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY FMCG",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY IT",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY MEDIA",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY METAL",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY PHARMA",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY PRIVATE BANK",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY PSU BANK",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY REALTY",
    label: "Sectoral Indices"
  },
  {
    name: "NIFTY COMMODITIES",
    label: "Thematic Indices"
  },
  {
    name: "Nifty INDIA CONSUMPTION",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY CPSE",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY INFRASTRUCTURE",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY MNC",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY PSE",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY SME EMERGE",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY SERVICES SECTOR",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY SHARIAH 25",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY50 SHARIAH",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY500 SHARIAH",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY ADITYA BIRLA GROUP",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY MAHINDRA GROUP",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY TATA GROUP",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY TATA GROUP 25% CAP",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY100 LIQUID 15",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY MIDCAP LIQUID 15",
    label: "Thematic Indices"
  },
  {
    name: "NIFTY ALPHA LOW-VOLATILITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY QUALITY LOW-VOLATILITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY ALPHA QUALITY LOW-VOLATILITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY ALPHA QUALITY VALUE LOW-VOLATILITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY50 Equal Weight",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY100 Equal Weight",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY100 LOW VOLATILITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY ALPHA 50",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY DIVIDEND OPPORTUNITIES 50",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY HIGH BETA 50",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY LOW VOLATILITY 50",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY QUALITY 30",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY50 VALUE 20",
    label: "Strategic Indices"
  },
  {
    name: "NIFTY GROWTH SECTORS 15",
    label: "Strategic Indices"
  }
];
